import { CONTRACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import PortalIdParser from 'PortalIdParser';
import { ObjectSource } from '../../../constants';
export function isContract(objectTypeId) {
  return objectTypeId === CONTRACT_TYPE_ID;
}
export function isActionUnavailable({
  objectId,
  objectTypeId,
  skip
}) {
  return Boolean(skip || !isContract(objectTypeId) || !objectId || objectId === -1);
}
export const getCPQQuoteEditorRoute = contentId => `/quote/${PortalIdParser.get()}/editor/${contentId}/content?redirectUrl=${encodeURIComponent(window.location.href)}`;
export function setHref(url) {
  window.location.href = url;
}
export function isCPQContract(source) {
  return source === ObjectSource.API;
}